import { EuiAppConfig, EuiGrowlService } from '@eui/core';
import { GLOBAL } from './global';
import { MODULES } from './modules';

// Custom error handling for 429 because weblogic is changing the 429 statusText into 'Unknown'
const Custom429HttpErrorCallbackFn = (_error, injector) => {
    const growlService = injector.get(EuiGrowlService);
    growlService.growlError('Too Many Requests. Please try again later.');
};

const CustomHttpErrorCallbackFn = (httpErrorResponse, injector) => {
    const growlService = injector.get(EuiGrowlService);
    const errorCode = httpErrorResponse.error?.errorCode ?? 'Unknown error code';
    const detail =
        httpErrorResponse.error?.messageDetails?.[0]?.detail ??
        httpErrorResponse.error?.message ??
        'No details available';
    growlService.growlError(`${errorCode}: ${detail}`);
};

export const appConfig: EuiAppConfig = {
    global: GLOBAL,
    modules: MODULES,
    httpErrorHandler: {
        routes: [
            {
                path: '*',
                429: Custom429HttpErrorCallbackFn,
                default: CustomHttpErrorCallbackFn,
            },
        ],
    },
};
